import React from 'react';
import ReactDOM from 'react-dom';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { Provider } from 'react-redux';
import { store } from '../../../../store/store';
import NotificationDetail from './NotificationDetail';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';

loadDOMComponent({
	selector: 'react-notification-detail',
	callback: ({ container, context, props }: any) => {
		const notificationId = container.getAttribute('notificationId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<NotificationDetail notificationId={notificationId} />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
